import React from "react";
import PropTypes from "prop-types";

import {Box} from "@mui/material";

import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";

import {green50, green100, red50, red100, red500} from "assets/jss/main";

const green700 = "#1B7055";

function EvolutionBadge({label, positive}) {
    return (
        <Box sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            height: "24px",
            px: "8px",
            borderRadius: "4px",
            backgroundColor: positive ? green50 : red50,
            border: `1px solid ${positive ? green100 : red100}`,
            flexShrink: 0,
        }}>
            {positive ? (
                <TrendingUpIcon sx={{fontSize: 14, color: green700}}/>
            ) : (
                <TrendingDownIcon sx={{fontSize: 14, color: red500}}/>
            )}
            <span style={{
                color: positive ? green700 : red500,
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: 1
            }}>
                {label}
            </span>
        </Box>
    );
}

EvolutionBadge.propTypes = {
    label: PropTypes.string.isRequired,
    positive: PropTypes.bool,
};

export default EvolutionBadge;
